import React from 'react'

import { BrowserRouter as Router } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'

import GlobalStyle from './styles/global'
import light from './styles/themes/light'

import Routes from './routes/Routes'

const App: React.FC = () => {
  return (
    <ThemeProvider theme={light}>
      <Router>
        <Routes />
        <GlobalStyle />
      </Router>
    </ThemeProvider>
  )
}

export default App
